var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.34522 5.19814L1.25739 0.124392C1.09069 -0.0417463 0.820807 -0.041467 0.654389 0.125251C0.488101 0.291948 0.48853 0.561983 0.655249 0.72825L5.44023 5.50002L0.655077 10.2718C0.48838 10.438 0.48795 10.7079 0.654217 10.8746C0.737641 10.9582 0.846932 11 0.956222 11C1.06523 11 1.17409 10.9585 1.25737 10.8755L6.34522 5.80187C6.4255 5.72199 6.47056 5.61328 6.47056 5.50002C6.47056 5.38675 6.42537 5.27817 6.34522 5.19814Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.7785a8c45fad1f2dd31eadd4b1b1b79c.svg";
export { ForwardRef as ReactComponent };